import React from 'react'
import { Link } from 'react-router-dom'
import './HeaderTopBar.component.scss'

const HeaderTopBar = () => {
  return (
    <div className='header-top-bar'>
      <div className='header-top-bar__inner'>
        <div className='header-top-bar__content'>
          <a href='tel:18888261966' className='header-top-bar__phone'>
            1-888-826-1966
          </a>
          <Link to='/login' className='header-top-bar__agent-login'>
            Agent Login
          </Link>
        </div>
      </div>
    </div>
  )
}

export default HeaderTopBar
